import { useLocation, useParams } from "react-router-dom"

import { DisconnectionOverlay } from "@/components/DisconnectionOverlay"

import { TileView } from "../tiles.state"
import { TornOutTile } from "./TearOut/TornOutTile"

export const TornOutTileWrapper = () => {
  const { symbol } = useParams()
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const view = query.has("tileView")
    ? (query.get("tileView") as TileView)
    : TileView.Chart

  return (
    <>
      <DisconnectionOverlay />
      <div className="h-full w-full overflow-auto bg-primary">
        {symbol && <TornOutTile symbol={symbol} view={view} />}
      </div>
    </>
  )
}
